module.exports = __webpack_public_path__ + "img/ieshop_logo.49a5c88a.png";